<script>
	import { api } from "../api";
	import * as L from "leaflet";
	import { onMount, onDestroy } from "svelte";
	import SRS from "../components/SRS.svelte";
	import { addOverlay, globalOverlay, removeOverlay, getMap } from "../map";

  export let filterRadioId

	const devices = api.devices.store;
	let layer;
	onMount(() => {
		layer = L.layerGroup();
		addOverlay("SRS", layer, globalOverlay);
		layer.addTo(getMap());
	});
	onDestroy(() => {
		removeOverlay(layer, globalOverlay);
		layer.removeFrom(getMap());
	});
</script>

{#await api.devices.get() then _}
	{#each Object.values($devices) as device (device.id)}
		{#if device.type === "SRS" && device.latitude && device.longitude && device.state !== "DISCONNECTED"}
			<SRS {device} {layer} bind:filterRadioId={filterRadioId} />
		{/if}
	{/each}
{/await}
